import type { InputHTMLAttributes, ReactNode } from 'react';
import { cx } from '../lib/cx';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id'> {
  id: string;
  label: ReactNode;
  error?: string | undefined;
}

export function Checkbox({ id, label, error, className, ...rest }: CheckboxProps) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="flex cursor-pointer items-start gap-3 text-[14.5px] text-ink">
        <input
          id={id}
          type="checkbox"
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? `${id}-error` : undefined}
          className={cx(
            'mt-0.5 h-[18px] w-[18px] shrink-0 cursor-pointer rounded-[4px]',
            // Kvacica je udzbenicki primjer WCAG 1.4.11: granica mora biti 3:1.
            'border border-line-control text-accent accent-accent',
            className,
          )}
          {...rest}
        />
        <span>{label}</span>
      </label>
      {error && (
        <p id={`${id}-error`} role="alert" className="pl-[30px] text-[12px] text-danger">
          {error}
        </p>
      )}
    </div>
  );
}
